import {
  parentNumber, angleValue, fixedNode
} from '../common/node'

const initialNodes = {
  status: { 0: 'closed', l: 'opening', m: 'opening', r: 'closed', i: 'closed' },
  x: { 0: 200, r: 300 },
  y: { 0: 200, r: 300 },
  lastClickedNumber: '',
  lastClickedId: '',
  clickedId: {},
  activeNode: '0',
  isClicking: false,
  isLoading: false,
  NodeId: false,
  groundClicking: false,
  mx: 0, my: 0,
  locale: 'ja',
  rootNumber: 0,
  zoom: 0,
}

export const client = (state = initialNodes, action) => {
  let x = {}, y = {}, d = {}, s = {}, cl ={}
  switch (action.type) {
    case 'INITIAL_POSITION':
      x[action.number] = action.width/2 - 75
      y[action.number] = action.height/2 -75
      return {
        ...state,
        activeNode: action.number,
        x: Object.assign(state.x, x),
        y: Object.assign(state.y, y),
      }
    case 'FETCH_INITIAL_SUCCESS':
      s['0'] = 'opening'
      return {
        ...state,
        lastClickedNumber: '0',
        status: Object.assign(state.status, s),
        locale: action.response.InitialNodes.locale
      }
    case 'LOAD_NODES':
      return{
        ...state,
        isLoading: action.isLoading
      }
    case 'RESET_CLIENT':
      let rx = (state.x[0] > 430) ? 20 : (state.x[0] - 430)
      return {
        ...state,
        x: { 0: state.x[0], r: rx, i: rx },
        y: { 0: state.y[0], r: 50, i: 380 },
        status: { 0: 'closed', l: 'opening', m: 'opening'},
        lastClickedNumber: null,
        lastClickedId: null,
        clickedId: {},
        activeNode: '0',
        isClicking: false,
        NodeId: false,
        rootNumber: 0
      }
    case 'FETCH_NODES_SUCCESS':
      let number = action.response.number
      x[number] = state.x[-1]
      y[number] = state.y[-1]
      s[number] = 'opening'
      for (let i = 0; i < action.response.ancients.length; i++) {
        x[parentNumber(number)] = x[number] - 350
        y[parentNumber(number)] = y[number]
        s[parentNumber(number)] = 'opened'
        number = parentNumber(number)
      }
      return {
        ...state,
        x: Object.assign(state.x, x),
        y: Object.assign(state.y, y),
        status: Object.assign(state.status, s),
        fetchNodeNumber: action.response.number,
        NodeId: true,
        rootNumber: state.rootNumber + 1,
        activeNode: action.response.number
      }
    case 'CLICK_NODE':
      if(state.status[parentNumber(action.number)] === 'opening') {
        return state
      }
      if(state.status[action.number]==='opened') {
        if(state.activeNode === action.number) {
          return {
            ...state,
            lastClickedNumber: action.number,
            isClicking: true,
            mx: (pageX(action.event)-state.x[action.number]),
            my: (pageY(action.event)-state.y[action.number]),
          }
        }
        return {
          ...state,
          activeNode: action.number,
        }
      }
      s[action.number] = 'opening'
      if(action.number!==0) {
        let parent = parentNumber(action.number)
        let angle = angleValue(action.x, action.y,
          state.x[parent], state.y[parent])
        x[parent] = (action.x+shiftedX(500, angle))
        y[parent] = (action.y+shiftedY(500, angle))
        let rangeKeysG = []
        let rangeKeysL = []
        for(let key in state.x) {
          if(state.x[key] === null || key === action.number) {
            continue
          }
          if(Number(key.slice(0,1)) !== state.rootNumber && key !== 'r' && key !== 'i') {
            continue
          }
          let range = inRange(state.x[key], state.y[key], action.x, action.y, 500)
          if(range !== 0) {
            state.x[key] = range
          }
          if( (state.y[key] <= (action.x+500)) && ( state.y[key] >= (action.y-500)) ) {
            if(state.x[key] > action.x) {
              rangeKeysG.push({ key: key, x: state.x[key]})
            } else {
              rangeKeysL.push({ key: key, x: state.x[key]})
            }
          }
        }

        rangeKeysG.sort(function(a,b){
          if(a.x < b.x) return -1;
          if(a.x > b.x) return 1;
          return 0;
        })
        rangeKeysL.sort(function(a,b){
          if(a.x > b.x) return -1;
          if(a.x < b.x) return 1;
          return 0;
        })

        for(let i=0; i < rangeKeysG.length; i++) {
          if(rangeKeysG[i+1] == undefined) {
            break
          }
          if((rangeKeysG[i+1].x - rangeKeysG[i].x) < 400) {
            rangeKeysG[i+1].x = (rangeKeysG[i].x + 400)
            x[rangeKeysG[i+1].key] = (rangeKeysG[i].x + 400)
          }
        }

        for(let i=0; i < rangeKeysL.length; i++) {
          if(rangeKeysL[i+1] == undefined) {
            break
          }
          if((rangeKeysL[i].x - rangeKeysL[i+1].x) < 400) {
            rangeKeysL[i+1].x = (rangeKeysL[i].x - 400)
            x[rangeKeysL[i+1].key] = (rangeKeysL[i].x - 400)
          }
        }

      }
      x[action.number] = action.x
      y[action.number] = action.y
      d[action.number] = 0
      cl[action.id] = true
      let lc = fixedNode(action.id) ? state.lastClickedId : action.id
      return {
        ...state,
        lastClickedNumber: action.number,
        lastClickedId: lc,
        activeNode: action.number,
        isClicking: true,
        mx: pageX(action.event)-action.x,
        my: pageY(action.event)-action.y,
        x: Object.assign(state.x, x),
        y: Object.assign(state.y, y),
        status: Object.assign(state.status, s),
        clickedId: Object.assign(state.clickedId, cl)
      }
    case 'CLICK_WIDGET':
      return {
        ...state,
        lastClickedNumber: action.number,
        activeNode: 'e',
        isClicking: true,
        mx: pageX(action.event)-state.x[action.number],
        my: pageY(action.event)-state.y[action.number],
      }
    case 'HANDLE_MOUSE_MOVE':
      if(state.isClicking){
        x[state.lastClickedNumber] = (pageX(action.event)-state.mx )
        y[state.lastClickedNumber] = (pageY(action.event)-state.my )
        return {
          ...state,
          x: Object.assign(state.x, x),
          y: Object.assign(state.y, y)
        }
      }
      if(state.groundClicking){
        for(let key in state.x){
          if(state.x[key] != null){
            x[key] = (state.x[key] + pageX(action.event)-state.mx)
            y[key] = (state.y[key] + pageY(action.event)-state.my)
          }
        }
        return {
          ...state,
          x: Object.assign(state.x, x),
          y: Object.assign(state.y, y),
          mx: pageX(action.event),
          my: pageY(action.event)
        }
      }
      return state;
    case 'HANDLE_MOUSE_DOWN':
      if(!state.isClicking) {
        return {
          ...state,
          groundClicking: true,
          mx: pageX(action.event),
          my: pageY(action.event)
        }
      }
      return state;
    case 'HANDLE_MOUSE_UP':
      return {
        ...state,
        isClicking: false,
        groundClicking: false
      }
    // case 'HANDLE_SCROLL':
    //   for(let key in state.x){
    //     if(state.x[key] != null){
    //       x[key] = (state.x[key] - action.event.deltaX)
    //       y[key] = (state.y[key] - action.event.deltaY)
    //     }
    //   }
    //   return {
    //     ...state,
    //     x: Object.assign(state.x, x),
    //     y: Object.assign(state.y, y)
    //   }
    case 'OPEN_NODE':
      s[action.number] = 'opened'
      return {
        ...state,
        status: Object.assign(state.status, s)
      }
    case 'CLOSING_NODE':
      s[action.number] = 'closing'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'CLOSE_NODE':
      x = state.x
      y = state.y
      let parent
      if(!action.root){
        parent = parentNumber(action.number)
        x[parent] = state.x[action.number]
        y[parent] = state.y[action.number]
        x[action.number] = null
        y[action.number] = null

        let shift = 0
        for(let key in x) {
          if(x[key] === null || key === parent) {
            continue
          }
          shift = inRange(x[key], y[key], x[parent], y[parent], 500)
          if(shift !== 0) {
            x[key] = shift
          }
        }
      }
      s[action.number] = 'closed'
      return {
        ...state,
        activeNode: parent,
        status: Object.assign(state.status, s),
        x: Object.assign(state.x, x),
        y: Object.assign(state.y, y),
      }
    case 'DELETE_NODE_SUCCESS':
      if(action.root) {
        return state
      }
      parent = parentNumber(action.number)
      x = state.x
      x[parent] = state.x[action.number]
      y = state.y
      y[parent] = state.y[action.number]
      delete x[action.number]
      delete y[action.number]
      s = state.status
      delete s[action.number]
      return {
        ...state,
        activeNode: parent,
        status: Object.assign(state.status, s),
        x: Object.assign(state.x, x),
        y: Object.assign(state.y, y),
        lastClickedNumber: parent,
      }
    case 'FETCH_NEXT_PAGE_SUCCESS':
    case 'NEXT_PAGE_SUCCESS':
      s[action.number] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'FETCH_NEXT_USER_PAGE_SUCCESS':
    case 'NEXT_USER_PAGE_SUCCESS':
      s['m.0'] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'FETCH_NEXT_LIKED_PAGE_SUCCESS':
    case 'NEXT_LIKED_PAGE_SUCCESS':
      s['m.2'] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'PREVIOUS_PAGE':
      s[action.number] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'PREVIOUS_USER_PAGE':
      s['m.0'] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'PREVIOUS_LIKED_PAGE':
      s['m.2'] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
      }
    case 'SET_LOCALE':
      return {
        ...state,
        locale: action.locale
      }
    case 'CREATE_NODE_SUCCESS':
      s[action.number] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s)
      }
    case 'FETCH_NODER_NODES_SUCCESS':
      s['e'] = 'opening'
      return {
        ...state,
        status: Object.assign(state.status, s),
        activeNode: 'e'
      }
    case 'CALL_WIDGET':
      x = state.x
      x['r'] = 200
      y['r'] = 100
      let shift = 0
      for(let key in x) {
        if(x[key] === null || key === 'r') {
          continue
        }
        shift = inRange(x[key], y[key], x['r'], y['r'], 500)
        if(shift !== 0) {
          x[key] = shift
        }
      }
      return {
        ...state,
        x: Object.assign(state.x, x),
        y: Object.assign(state.y, y)
      }
    case 'SET_ZOOM':
      return {
        ...state,
        zoom: action.value
      }
    // case 'STAMP_NODE_SUCCESS':
      // if(state.status[action.number] === undefined){
      //   s[action.number] = 'opening'
      // }
      // return {
      //   ...state,
      //   status: Object.assign(state.status, s)
      // }
    default:
      return state;
  }
};

const shiftedX = (redius, angle) => (
  redius*Math.cos(angle)
)

const shiftedY = (redius, angle) => (
  redius*Math.sin(angle)
)

const pageX = e => {
  if(e.touches!=null){
    return(e.touches[0].pageX)
  }else{
    return(e.pageX)
  }
}

const pageY = e => {
  if(e.touches!=null){
    return(e.touches[0].pageY)
  }else{
    return(e.pageY)
  }
}

const inRange = (x, y, ax, ay, range) => {
  if( (y > (ay+range)) || ( y < (ay-range)) ) {
    return 0
  }
  if( (x > (ax+range)) || ( x < (ax-range)) ) {
    return 0
  }
  let xx = (x < ax) ? ((ax-range) + ((x-ax)/50)) : ((ax+range) + ((ax-x)/50))
  return xx
}

export default client;



// WEBPACK FOOTER //
// ./src/reducers/client.js